import { Injectable, inject } from '@angular/core';
import { DataService } from '@core/services/data.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IReportCard, IReportCardDistrictCount, IReportCardInactiveCount, IReportCardRequest, IReportCardSchoolCount } from '../interfaces/ireport-card';
import { ISearchCompletionResponse, ISearchReportResponse } from '../interfaces/ireport-response';
import { IReportRequest } from '../interfaces/ireport-request';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  dataService = inject(DataService);

  //   private readonly _district$ = new BehaviorSubject<IReportCardRequest | null>(null);
  // readonly reportSubject$ = this._district$.asObservable();

  // setDistrict(data: IReportCardRequest | null): void {
  //   this._district$.next(data);
  // }


  getCardInfo(payload: IReportCardRequest): Observable<IReportCard> {
    return this.dataService.post(`userCourse/card-info`, payload);
  }

  getCardInfoWithoutGlobalLoading(payload: IReportCardRequest): Observable<IReportCard> {
    return this.dataService.postWithoutLoading<IReportCard>(`userCourse/card-info`, payload);
  }

  getCardInactiveInfo(districtId?: number): Observable<IReportCardInactiveCount> {
    const payload: IReportCardRequest = { districtId };
    return this.dataService.post(`userCourse/card-inactive-info`, payload);
  }

  searchReport(payload: IReportRequest): Observable<ISearchReportResponse> {
    return this.dataService.post(`userCourse/search`, payload);
  }

  searchDistrictCompletionReport(payload: IReportRequest): Observable<ISearchCompletionResponse> {
    return this.dataService.post(`userCourse/search-district-completion`, payload);
  }

  searchSchoolCompletionReport(payload: IReportRequest): Observable<ISearchCompletionResponse> {
    return this.dataService.post(`userCourse/search-school-completion`, payload);
  }

  downloadReport(payload: IReportRequest): Observable<any> {
    return this.dataService.postWithOptions('userCourse/download', payload, {
      observe: 'response',
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  }

  downloadDistrictCompletionReport(payload: IReportRequest): Observable<any> {
    return this.dataService.postWithOptions('userCourse/download-district-completion', payload, {
      observe: 'response',
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  }

  getDistrictCount(): Observable<IReportCardDistrictCount[]> {
    return this.dataService.get(`district/district-count`);
  }

  getDistrictCountWithoutGlobalLoading(): Observable<IReportCardDistrictCount[]> {
    return this.dataService.get(`district/district-count`, undefined, false);
  }

  getSchoolCount(districtId: number | null): Observable<IReportCardSchoolCount[]> {
    return this.dataService.get(`school/school-count/district/${districtId}`);
  }

  getSchoolCountWithoutGlobalLoading(districtId: number | null): Observable<IReportCardSchoolCount[]> {
    return this.dataService.get(`school/school-count/district/${districtId}`, undefined, false);
  }
}
